import React from "react";

const DividerBar = ({ size, withoutMargins }) => {
  return (
    <hr
      className={
        size === "big"
          ? "clear" + (withoutMargins ? " tps-no-margin" : "")
          : "tps-short"
      }
    />
  );
};

export default DividerBar;
